<template>
    <div
        @click="onClick"
        data-cy="loginButton"
        class="modal-button"
        :style="{ background: $Utils.colors[color] }"
        :class="{ '-disabled': disabled, '-blocked': blocked }"
    >
        <transition name="fade" mode="out-in">
            <div class="button-loader" v-if="loading">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div v-else v-text="$t(label)" />
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        label: String,
        loading: Boolean,
        blocked: Boolean,
        disabled: { type: Boolean, default: false },
        color: {
            type: String,
            default: ''
        }
    },
    methods: {
        onClick($event) {
            if (this.disabled) {
                return
            }
            this.$emit('click', $event)
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-button {
    margin-top: 1rem;
    border-radius: $input-radius;
    width: 100%;
    font-size: 1.2rem;
    font-family: $input-family;
    cursor: pointer;
    transition: $ease;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $action-accent;
    color: $container-background;
    height: 3rem;
    user-select: none;

    &:hover {
        transform: $translateY;
    }

    &.-disabled {
        background-color: grey;
        pointer-events: none;
    }
    &.-blocked {
        color: $accent-label;
        border-color: $accent-label;
        cursor: default;

        &:hover {
            transform: none;
        }
    }
}
.button-loader {
    div {
        background: #fff;
    }
}
</style>
